import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { ConnectionService } from '../../../core/services/connection.service';
import { ButtonComponent } from '../../../shared/ui';

@Component({
  selector: 'app-connection-overlay',
  imports: [ButtonComponent, CommonModule],
  templateUrl: './connection-overlay.component.html',
  styleUrl: './connection-overlay.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConnectionOverlayComponent {
  private readonly connectionService = inject(ConnectionService);
  private readonly destroyRef = inject(DestroyRef);

  public readonly isConnected = signal(true);
  public readonly isRetrying = signal(false);

  public constructor() {
    this.connectionService.isConnected$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((isConnected) => {
        this.isConnected.set(isConnected);
      });
  }

  public retryConnection(): void {
    this.isRetrying.set(true);
    this.connectionService
      .checkConnection()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => this.isRetrying.set(false),
        error: () => this.isRetrying.set(false),
      });
  }
}
